<!--
 * @Author: Nie Wie
 * @Date: 2020-03-25 11:07:54
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-04-02 15:29:57
 * @Description: 开工月报
 -->

<template>
  <div>
    <data-card class="work-module"></data-card>
    <!-- <sorted-sta class="work-module"></sorted-sta> -->
    <total-sta class="work-module"></total-sta>
    <!-- <seq-grow class="work-module"></seq-grow> -->
    <cover-sta class="work-module"></cover-sta>
  </div>
</template>

<script>
import DataCard from './data-card'
// import SortedSta from './statistic-sort'
import TotalSta from './statistic-total'
// import SeqGrow from './sequential-growth'
import CoverSta from './cover-statistics'

export default {
  components: {
    DataCard,
    // SortedSta,
    TotalSta,
    // SeqGrow,
    CoverSta,
  },

}
</script>

<style>
.work-module {
  margin-bottom: 50px;
}
</style>
